import { useEffect } from "react";
import { TFormHookParams, IFormSection } from "../../types/common";
import useGet from "../common/useGet";
import {
  API_ACCOUNTS_ROLES,
  API_DISTRICTS,
  API_WAGES_BONUS,
} from "../../utils/apis";
import { addSelectItem, getRegister } from "../../utils/helpers";
import { URL_WAGES_BONUS } from "../../utils/urls";

export const useWagesBonusForm = ({
  id,
  updateFormValues,
  form,
}: TFormHookParams = {}) => {
  const isUpdate = !!id;
  const {
    loadData: getDistricts,
    data: districts,
    loading: loadingDistricts,
  } = useGet();
  const { loadData: getRoles, data: roles, loading: loadingRoles } = useGet();

  useEffect(() => {
    if (isUpdate && form) {
      updateFormValues?.({
        ...form,
        city: form.city?.id || form.city,
      });
    }
  }, [form, isUpdate, updateFormValues]);

  useEffect(() => {
    getDistricts({ api: API_DISTRICTS });
    getRoles({ api: API_ACCOUNTS_ROLES });
  }, []);

  const sections: IFormSection[] = [
    {
      title: "Bonus Details",
      fields: [
        {
          field_name: "city",
          type: "select",
          label: "City",
          props: {
            required: isUpdate ? false : true,
            disabled: isUpdate,
            placeholder: "Select City",
          },
          options_data: districts,
          value: form?.city,
          loading: loadingDistricts,
        },
        {
          field_name: "bonus_name",
          type: "text",
          label: "Bonus Name",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "staff_type",
          type: "select",
          label: "Roles",
          props: {
            required: isUpdate ? false : true,
            disabled: isUpdate,
            placeholder: "Select Role",
          },
          options_data: roles?.results?.map((sup: any) =>
            addSelectItem({
              label: sup?.name,
              value: sup?.name?.toUpperCase(),
            }),
          ),
          loading: loadingRoles,
        },
        {
          field_name: "threshold_amount",
          type: "number",
          label: "Threshold Amount",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "bonus_amount",
          type: "number",
          label: "Bonus Amount",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "is_active",
          label: "Status",
          type: "select",
          visible: isUpdate,
          props: {
            required: isUpdate ? false : true,
            options: [
              { value: true, label: "Active" },
              { value: false, label: "Inactive" },
            ],
          },
        },
      ],
    },
  ];

  const title = "Wages Bonus";
  const redirect = getRegister(URL_WAGES_BONUS);

  const onSubmit = (payload: any) => {
    if (id) {
      return {
        id,
        api: API_WAGES_BONUS,
        params: {
          ...payload,
        },
      };
    }
    return {
      api: API_WAGES_BONUS,
      params: {
        ...payload,
      },
    };
  };

  return {
    sections,
    onSubmit,
    title,
    redirect,
  };
};
